import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import TemplateCard from './TemplateCard';

const GridContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '40px',
  width: '100%',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '32px'
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
    gap: '28px'
  }
}));

const TemplateGrid = ({ templates, selectedTemplate, onTemplateSelect, onPreview, onUseTemplate }) => {
  return (
    <GridContainer>
      {templates.map((template, index) => (
        <TemplateCard
          key={template.id}
          template={template}
          selected={selectedTemplate?.id === template.id}
          onClick={() => onTemplateSelect(template)}
          onPreview={onPreview}
          onUseTemplate={onUseTemplate}
          isFirst={index === 0}
        />
      ))}
    </GridContainer>
  );
};

export default TemplateGrid;